import { ICurrentUser } from "../../shared/models/interfaces/current-user";
import { SetCurrentUser, ClearCurrentUser, CurrentUserActions, SET_CURRENT_USER, CLEAR_CURRENT_USER } from "./current-user.actions";

export interface CurrentUserState {
  currentUser: ICurrentUser | null;
}

const initialState: CurrentUserState = {
  currentUser: null,
};

export function currentUserReducer(
  state: CurrentUserState = initialState,
  action: CurrentUserActions
): CurrentUserState {
  console.log('Reducer called with action:', action);
  
  switch (action.type) {
    case SET_CURRENT_USER:
      console.log('Setting current user:', action.payload);
      return { ...state, currentUser: action.payload };
    case CLEAR_CURRENT_USER:
      console.log('Clearing current user');
      return { ...state, currentUser: null };
    default:
      console.log('Action not recognized, returning current state');
      return state;
  }
}


